import { createFileRoute } from '@tanstack/react-router';
import { HealthProfileScreen } from '../../screens/health/HealthProfile';

export const Route = createFileRoute('/health/profile')({
  component: HealthProfileScreen,
});
